<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select class="filter-item" v-model="listQuery.querymodel.SectionId" placeholder="请选择路段" collapse-tags
        :clearable="true" @change="getList()">
        <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName" :value="item.Id"></el-option>
      </el-select>
      <el-date-picker @change="datechange" class="filter-item" v-model="querydate" type="datetimerange"
        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
      </el-date-picker>
      <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="车牌号" style="width: 200px"
        @keyup.enter.native="getList()" />
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    </div>
    <el-table class="app-table" :data="list" border fit highlight-current-row stripe ref="orderrecordtable" show-summary
      :summary-method="getSummaries" style="width: 100%" :height="getViewHeight()"
      :header-cell-style="{ background: '#F3F4F7', color: '#555' }" :row-style="{ height: '10px' }"
      :cell-style="{ padding: '7px 0' }">
      <el-table-column :key="i" v-for="(col, i) in columns" :label="col.label" :align="col.align" :prop="col.value"
        :type="col.type" :width="col.width" :formatter="col.formatter == true ? tableformatter : null">
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
      @pagination="getList" />
  </div>
</template>
<script>
import { GetSkipSummary as getgoodssalereport } from "@/api/order";
import { query as querysectionlist } from "@/api/section";
import { MrYangUtil } from "../../utils/time.js";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
export default {
  components: { Pagination, Toolbar },
  directives: { waves },
  data() {
    return {
      dialogshow: false,
      buttonList: [],
      downloadLoading: false,
      authedit: false,
      authdelete: false,
      list: [],
      pageIndex: 1,
      total: 0,
      orderrecordmain: {},
      buscost: {
        dialogshow: false,
        editform: {},
        isedit: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              const start = new Date();
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              let s = MrYangUtil.getCurrentWeek()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentWeek()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              let s = MrYangUtil.getCurrentMonth()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentMonth()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              let s = MrYangUtil.getPreviousMonth()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getPreviousMonth()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "本年",
            onClick(picker) {
              let s = MrYangUtil.getCurrentYear()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentYear()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
        ],
      },
      querydate: "",
      columns: [
        {
          label: "序号",
          value: "index",
          align: "center",
          type: "index",
          width: 100,
        },
        { label: "车牌号码", value: "LicencePlate", align: "center", type: "" },
        { label: "跑单次数", value: "OrderCount", align: "center" },
        { label: "跑单金额", value: "OrderAmount", align: "center" }
      ],
      servicetime: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          keyword: "",
        },
      },
    };
  },
  created() {
    let start = MrYangUtil.getCurrentYear()[0];
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    let end = MrYangUtil.getCurrentYear()[1];
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
    start.setTime(start.getTime() + this.servicetime);
    end.setTime(end.getTime() + this.servicetime);
    this.querydate = [start, end];
    this.listQuery.querymodel.begintime = start;
    this.listQuery.querymodel.endtime = end;
    querysectionlist({
      pageSize: 10000,
    }).then((res) => {
      this.sectionlist = res.data;
    });
    this.getList();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["orderrecordtable"].doLayout();
    });
  },
  methods: {
    tableformatter(row, column, cellValue) {
      switch (column.property) {
        case "PayAmount":
          return Number(cellValue).toFixed(2);
      }
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "总计：";
          return;
        }
        if (this.orderrecordmain[column.property] != undefined) {
          sums[index] = Number(this.orderrecordmain[column.property]).toFixed(
            2
          );
        }
      });
      return sums;
    },
    datechange(item) {
      if (item.length === 3) {
        this.querydate = [item[0], item[1]];
        this.querydate[0].setTime(
          this.querydate[0].getTime() + this.servicetime
        );
        this.querydate[1].setTime(
          this.querydate[1].getTime() + this.servicetime
        );
      }
      this.listQuery.querymodel.begintime = this.querydate[0];
      this.listQuery.querymodel.endtime = this.querydate[1];
      this.getList();
    },
    callFunction(item) {
      this[item.BtnCode].apply(this, item);
    },
    savecomplete(item) {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      getgoodssalereport(this.listQuery).then((res) => {
        this.orderrecordmain = res.maindata;
        this.list = res.data;
        this.total = res.dataCount;
      });
    },
    edit(row) {
      this.buscost.dialogshow = true;
      this.buscost.isedit = true;
      this.buscost.editform = row;
    },
    savebuscostcomplete(item) {
      this.buscost.dialogshow = false;
      this.$message({
        message: "修改记账成功！",
        type: "success",
      });
      this.getList();
    },
    cancelbuscostcomplete() {
      this.buscost.dialogshow = false;
    },
    deleted(row) {
      this.$confirm("确定删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleted({ id: row.Id }).then((res) => {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.getList();
        });
      });
    },
    m_export() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [];
        const filterVal = [];
        this.columns.forEach((item) => {
          tHeader.push(item.label);
          filterVal.push(item.value);
        });
        const exportquery = JSON.parse(JSON.stringify(this.listQuery));
        let index = 1;
        exportquery.pageIndex = 1;
        exportquery.pageSize = 1000000;
        exportquery.mergeSize = false;
        getgoodssalereport(exportquery).then((res) => {
          const orderrecordmain = res.maindata;
          orderrecordmain.GoodsName = "总计：";
          res.data.push(orderrecordmain);
          const data = res.data.map((v) =>
            filterVal.map((j) => {
              if (j === "index") {
                return index++;
              } else {
                return v[j];
              }
            })
          );
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "车辆跑单统计",
          });
          this.downloadLoading = false;
        });
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.buttonList.forEach((item) => {
      if (item.BtnCode === "delete") {
        this.authdelete = true;
      }
      if (item.BtnCode === "edit") {
        this.authedit = true;
      }
    });
  },
};
</script>